import {
    Box,
    Checkbox,
    FormControlLabel,
    Grid,
    Typography,
} from "@mui/material"
import { useForm, SubmitHandler } from "react-hook-form"
import { StyledTextField } from "components/inputs/StyledTextField.tsx"
import { ChangeEvent, useState } from "react"
import { OreveButton } from "components/button/OreveButton.tsx"
import AddIcon from "@mui/icons-material/Add"
import {
    OrevePopup,
    OrevePopupContent,
    OrevePopupTitle,
} from "components/popup/OrevePopup.tsx"
import {
    ForwardedFormattedBankNumberTextField,
    ForwardedFormattedExpirationDateTextField,
    ForwardedFormattedCVVTextField,
} from "layouts/payment/popup/inputFormat.tsx"

interface IPaymentMethod {
    paymentType: "creditCard" | "currentAccount"
    cardName?: string
    cardNumber?: string
    cvv?: string
    expirationDate?: string
    iban?: string
    bic?: string
    accountHolder?: string
}

export const AddPaymentMethod = ({
    onClose,
    isOpen,
    paymentType, // "creditCard" ou "currentAccount"
}: {
    onClose: () => void
    isOpen: boolean
    paymentType: "creditCard" | "currentAccount"
}) => {
    const { register, handleSubmit } = useForm<IPaymentMethod>()
    const [defaultPayment, setDefaultPayment] = useState(true)

    const onSubmit: SubmitHandler<IPaymentMethod> = (data) => {
        console.log(data)
    }

    const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
        setDefaultPayment(event.target.checked)
    }

    return (
        <OrevePopup open={isOpen} handleClose={onClose}>
            <OrevePopupTitle>
                <Typography variant="headlineSmall">
                    {paymentType === "creditCard"
                        ? "Ajouter une carte de crédit"
                        : "Ajouter un compte courant"}
                </Typography>
            </OrevePopupTitle>
            <OrevePopupContent>
                {paymentType === "currentAccount" && (
                    <Typography
                        sx={{
                            color: "grey.600",
                            textAlign: "left",
                            mb: "1.5rem",
                        }}
                    >
                        En fournissant vos coordonnées bancaires et en validant
                        ce mandat, vous autorisez Oreve à envoyer des
                        instructions à votre banque pour débiter votre compte.
                    </Typography>
                )}

                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2} sx={{ mb: "1rem" }}>
                        {paymentType === "creditCard" ? (
                            <>
                                <Grid size={{ xs: 6 }}>
                                    <StyledTextField
                                        bgcolor={"grey.100"}
                                        label={"Nom de carte"}
                                        {...register("cardName", {
                                            required: true,
                                        })}
                                    />
                                </Grid>
                                <Grid size={{ xs: 6 }}>
                                    <ForwardedFormattedBankNumberTextField
                                        label={"Numéro de carte"}
                                        {...register("cardNumber", {
                                            required: true,
                                        })}
                                    />
                                </Grid>
                                <Grid size={{ xs: 6 }}>
                                    <ForwardedFormattedExpirationDateTextField
                                        label={"Date d'expiration"}
                                        {...register("expirationDate", {
                                            required: true,
                                        })}
                                    />
                                </Grid>
                                <Grid size={{ xs: 6 }}>
                                    <ForwardedFormattedCVVTextField
                                        label={"CVV/CVC"}
                                        {...register("cvv", { required: true })}
                                    />
                                </Grid>
                            </>
                        ) : (
                            <>
                                <Grid size={{ xs: 12 }}>
                                    <StyledTextField
                                        bgcolor={"grey.100"}
                                        label={"IBAN"}
                                        {...register("iban", {
                                            required: true,
                                        })}
                                    />
                                </Grid>
                                <Grid size={{ xs: 6 }}>
                                    <StyledTextField
                                        bgcolor={"grey.100"}
                                        label={"BIC (Swift-Code)"}
                                        {...register("bic", { required: true })}
                                    />
                                </Grid>
                                <Grid size={{ xs: 6 }}>
                                    <StyledTextField
                                        bgcolor={"grey.100"}
                                        label={"Titulaire du compte"}
                                        {...register("accountHolder", {
                                            required: true,
                                        })}
                                    />
                                </Grid>
                            </>
                        )}
                    </Grid>

                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <FormControlLabel
                            sx={{ mb: "1rem" }}
                            control={
                                <Checkbox
                                    checked={defaultPayment}
                                    onChange={handleCheckboxChange}
                                    sx={{
                                        color: (theme) =>
                                            theme.palette.secondary.main,
                                        "&.Mui-checked": {
                                            color: (theme) =>
                                                theme.palette.secondary.main,
                                        },
                                    }}
                                />
                            }
                            label="Définir comme mode de paiement par défaut"
                        />
                        <OreveButton
                            type="submit"
                            variant={"contained"}
                            color={"primary"}
                            value={
                                paymentType === "creditCard"
                                    ? "Ajouter une carte"
                                    : "Ajouter un compte"
                            }
                            icon={AddIcon}
                            loading={false}
                        />
                    </Box>
                </form>
            </OrevePopupContent>
        </OrevePopup>
    )
}
